export const NO_ENGAGE_ANSWERS = -1;
export const ALL_UNITS = -2;

export const REPORT_TYPE_EXTERNAL = "ExternalReport";
